"use client";
import {
  Center,
  Divider,
  Flex,
  Text,
  Grid,
  GridItem,
  Heading,
  UnorderedList,
  ListItem,
  Stack,
} from "@chakra-ui/react";
import Image from "next/image";
import {
  useTextVariants,
  useSectionHeadingVariant,
} from "@/theme/components/useSectionHeading";
import { REASON_COMP } from "./constants";

const ReasonComp = () => {
  const HeadingVariants = useSectionHeadingVariant();
  const TextVariant = useTextVariants();
  const { image, title, points } = REASON_COMP;
  return (
    <Stack spacing={8}>
      <Heading as="h2" variant={HeadingVariants} textAlign={"center"}>
        {title}
      </Heading>
      <Grid
        gap={{ base: 4, md: 8 }}
        backgroundColor="#555555"
        templateColumns={{
          base: "repeat(1, 1fr)",
          md: "repeat(4, 1fr)",
        }}
        borderRadius={"16px"}
      >
        <GridItem colSpan={{ base: 1, md: 1 }} pt={{ base: 8, md: 4 }}>
          <Center height={"full"}>
            <Image
              src={image}
              alt={"image"}
              style={{
                borderRadius: "20px",
                maxHeight: "300px",
                objectFit: "contain",
                objectPosition: "center",
              }}
            />
          </Center>
        </GridItem>
        <GridItem colSpan={{ base: 1, md: 3 }} px={2} py={{ base: 2, md: 12 }}>
          <Flex
            direction={{ base: "column", md: "row" }}
            alignItems="center"
            height="100%"
          >
            <Divider orientation="vertical" color="white" height="100%" />
            <UnorderedList ml={{ base: 0, md: 12 }} mt={{ base: 4, md: 0 }} spacing={4}>
              {points.map((point, index) => (
                <ListItem key={index} color="white">
                  <Text
                    key={index}
                    as="span"
                    variant={TextVariant}
                    color="white"
                    fontWeight={600}
                  >
                    {point.label} : {""}
                  </Text>
                  <Text key={index} as="span" variant={TextVariant} color="white">
                    {point.text}
                  </Text>
                </ListItem>
              ))}
            </UnorderedList>
          </Flex>
        </GridItem>
      </Grid>
    </Stack>
  );
};

export default ReasonComp;
